import { formatMoneyNumber } from './currency';

export const TRIAL_DAYS = 14;

export const REGIONS = {
  BR: { id: 'BR', flag: 'BR', name: 'Brasil', currency: 'BRL', symbol: '$' },
  US: { id: 'US', flag: 'US', name: 'Estados Unidos', currency: 'USD', symbol: '$' },
  EU: { id: 'EU', flag: 'EU', name: 'Europa', currency: 'EUR', symbol: '$' },
  OTHER: { id: 'OTHER', flag: '🌐', name: 'Outras', currency: 'USD', symbol: '$' },
};

export const PLAN_PRICES = {
  BR: {
    basic: 29.9,
    standard: 39.9,
  },
  US: {
    basic: 14.99,
    standard: 34.99,
  },
  EU: {
    basic: 17.99,
    standard: 39.99,
  },
  OTHER: {
    basic: 14.99,
    standard: 34.99,
  },
};

export const PLAN_LIMITS = {
  basic: 3,
  standard: 40,
};

export const normalizeRegion = (region) => (REGIONS[region] ? region : 'US');
export const normalizePlan = (plan) => (PLAN_LIMITS[plan] ? plan : 'basic');

export const getStoredRegion = () => {
  try {
    const stored = JSON.parse(localStorage.getItem('clarityRegion'));
    return normalizeRegion(stored?.id || stored?.region || stored);
  } catch {
    return 'US';
  }
};

export const getPlanRule = (regionValue, planValue) => {
  const region = normalizeRegion(regionValue);
  const plan = normalizePlan(planValue);
  return {
    region,
    plan,
    amount: PLAN_PRICES[region][plan],
    limit: PLAN_LIMITS[plan],
    currency: REGIONS[region].currency,
    symbol: REGIONS[region].symbol,
    trialDays: TRIAL_DAYS,
  };
};

export const formatPlanPrice = (regionValue, planValue, language = 'pt-BR') => {
  const rule = getPlanRule(regionValue, planValue);
  return `${rule.symbol} ${formatMoneyNumber(rule.amount, { language })}`;
};

export const getPlanLabel = (planValue, t) => {
  const plan = normalizePlan(planValue);
  return plan === 'standard' ? t('plans.standard.title') : t('plans.basic.title');
};

export const needsSubscriptionRegularization = (subscription = {}) => (
  Boolean(subscription?.requiresPayment) ||
  subscription?.accessStatus === 'grace' ||
  subscription?.accessStatus === 'locked'
);

export const isSubscriptionLock = (access = {}, fallbackSubscription = {}) => (
  access?.reason === 'SUBSCRIPTION_REQUIRED' ||
  needsSubscriptionRegularization(access?.subscription || fallbackSubscription)
);

export const getSubscriptionRegularizationMessage = (subscription = {}, t, planOverride) => {
  const plan = getPlanLabel(planOverride || subscription?.plan || 'basic', t);
  if (subscription?.accessStatus === 'grace' && Number(subscription?.daysLeftInGrace || 0) > 0) {
    return t('plans.regularizeGraceMessage', { plan, count: Number(subscription.daysLeftInGrace || 0) });
  }
  return t('plans.regularizeMessage', { plan });
};
